import Alert from '@/common/components/alert';
import Button from '@/common/components/button';
import colors from '@/assets/constants/colors';
import Dropdown from '@/common/components/dropdown';
import Popup from '@/common/components/popup';
import Row from '@/common/components/row';
import spacings from '@/assets/constants/spacings';
import TextBox from '@/common/components/textbox';
import { editUser } from '@/services/api/organisation-service';
import { editUser as storeEditUser } from '@/store/general-slice';
import { getPronouns } from '@/common/helpers';
import { Headline } from '@/common/components/text';
import { IEditPopup } from './types';
import { IPopup } from '@/common/types';
import { useAppDispatch } from '@/store/hooks';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const EditUserPopup = ({ close, user }: IPopup & IEditPopup) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();

    const [name, setName] = useState<string>(user.name);
    const [email, setEmail] = useState<string>(user.email);
    const [pronouns, setPronouns] = useState<string>(user.pronouns);
    const [error, setError] = useState<boolean>(false);

    return (
        <Popup close={close}>
            <Headline quaternary mb={spacings.s}>
                {t('create.stepAttendees.editProfile')}
            </Headline>
            <TextBox
                disabled={true}
                label={t('forms.email')}
                value={email}
                setValue={setEmail} />
            <TextBox
                disabled={user.role === 'organiser'}
                label={t('forms.name')}
                value={name}
                setValue={setName}
                mt={spacings.xs} />
            <Dropdown
                disabled={user.role === 'organiser'}
                options={getPronouns()}
                label={t('forms.pronouns')}
                mt={spacings.xs}
                value={pronouns}
                setValue={setPronouns}
            />

            {error && <Alert
                mt={spacings.xs}
                bgColor={colors.Error}
                text={t('attendees.editError')}
            />}

            <Row mt={spacings.m} style={{ justifyContent: 'flex-end' }}>
                <Button
                    mr={spacings.xxs}
                    tertiary
                    label={t('actions.cancel')}
                    onClick={close} />
                <Button
                    disabled={!(name && email && pronouns) || user.role === 'organiser'}
                    label={t('attendees.saveAttendee')}
                    onClick={async () => {
                        setError(false);
                        if (!(name && email && pronouns)) return;
                        const [data, error] = await editUser({
                            name, email, pronouns
                        });
                        if (!error) {
                            dispatch(storeEditUser({ id: user.id, name, email, pronouns }));
                            close();
                        } else {
                            setError(true);
                        }
                    }} />
            </Row>
        </Popup>
    );
}

export default EditUserPopup;